import React, { useRef } from "react";
import logo from "assets/img/logo/logo_aig_login-2.png";

import { Card, CardBody, Row, Col, Label, Button, Alert } from "reactstrap";

import makeAnimated from "react-select/lib/animated";

import { sucursalesFetch } from "../../redux/actions/aRamos";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { fetchConsultarIdentificacionAP } from "../../redux/actions/aCotizacion";
import {
  fetchCrearCarritoAccP,
  fetchRecuperarCarritoAccP,
  fetchObtenerPlanes,
  fetchListarProvinciasAP,
  fetchListarCiudadesAP,
  fetchObtenerPlanesAigmed
} from "../../redux/actions/aRamoAccidentesPersonales";
import LoadingScreen from "react-loading-screen";

import Select from "react-select";
import {
  Textbox,
  Textarea,
  Select as Select1,
  Select as Select2,
  Select as Select3,
  Checkbox
} from "react-inputs-validation";
import "../../styles/estilos.css";
import Page from "components/Page";
import { ambienteAplicacion } from '../../constants/urls'
import { EquiRamos, ErrorMsgConstants } from "../../constants";
import { isDuplicateHogar } from "../../redux/actions/ACarritoProductos";

class CotizacionAccPersonal extends React.Component {

   messagesEndRef = React.createRef()

   scrollToBottom = () => {

   this.messagesEndRef.current.scrollIntoView({ behavior: 'smooth' })
  }
  constructor(props) {
    super(props);
    this.state = {
      validate: false,
      empresa: "",
      solicitante: "",
      ruc: "",
      cedula: "",
      idCarrito: "",
      hasEmpresaError: true,
      hasSolicitanteError: true,
      hasRucError: true,
      hasCedulaError: true,
      idAsesor: "",
      sucursalSeleccionada: "",
      loadingPaso: false,
      numPersonas: "",
      planes: [],
      planSeleccionado: "",
      nomPlanSeleccionado: "",
      desPlanSeleccionado: "",
      subPlanSeleccionado: "",
      nomSubPlanSeleccionado: "",
      subPlan: false,
      subPlanes: [],
      subPlanId: "",
      subPlanNombre: "",
      hasPlanError: true,
      numMin: "",
      hasProvinciaError: true,
      hasCiudadError: true,
      provinciaSelected: "",
      ciudadSelected: "",
      arrayProvincias: [],
      arrayCiudades: [],
      direccionSelected: "",
      cargandoCiudades: false,
      hasSucursalError: true,
      numPersonasCampo1: 0,
      numPersonasCampo2: 0,
      labelNumPersonasCampo1: "",
      labelNumPersonasCampo2: "",
      hasnumPersonasError: true,
      hasnumPersonas2Error: true,
      mostrarmensajeNumPersonas: true,
      msgNumeroPersonas: '',
      arrayPreguntas: undefined,
      msgErrorPreguntas: undefined,
      verMsgErrorPreguntas: false,
      actividadSelected: "",
      arrayActividades: [],
      actividadHasError: true,
      msgConfirmarRecalculo: null,
      planesAigmed: [],
      planesAigmedError: false,
      planAigmedSeleccionado: null,
      mostrarAigmed: false
    };

    this.validateForm = this.validateForm.bind(this);
  }






  toggleValidating(validate) {
    this.setState({ validate });
  }

  async validateForm(e) {
    const {
      cedula,
      ruc,
      empresa,
      solicitante,
      idCarrito,
      validate,
      loadingPaso,
      planSeleccionado,
      planAigmedSeleccionado,
      nomPlanSeleccionado,
      desPlanSeleccionado,
      numMin,
      subPlanSeleccionado,
      nomSubPlanSeleccionado,
      hasDireccionError,
      hasCiudadError,
      direccionSelected,
      ciudadSelected,
      numPersonas,
      hasSucursalError,
      sucursalSeleccionada,
      arrayPreguntas
    } = this.state;

    e.preventDefault();
    this.toggleValidating(true);
    const {
      hasEmpresaError,
      hasSolicitanteError,
      hasRucError,
      hasCedulaError,
      hasPlanError,
      numPersonasCampo1,
      numPersonasCampo2,
      hasnumPersonasError,
      hasnumPersonas2Error,
      actividadHasError,
      actividadSelected
    } = this.state;
    //Validar numero de personas


    let planesAigmedError = false
    let hasErrorNumeroPersonasValidacion = true
    let hasErrorResponderPreguntas = true
    let subplanValidador = true;
    if (this.state.planes && this.state.planSeleccionado) {
      let planElegido = this.state.planes.find(
        plan => plan.id === this.state.planSeleccionado
      );
      if (planElegido && (planElegido.numLabels === '2' || planElegido.numLabels === 2)) {
        if ((!hasnumPersonasError && !hasnumPersonas2Error) || (numPersonasCampo1 !== '' && numPersonasCampo2 !== '')) {
          if (parseInt(numPersonasCampo1) + parseInt(numPersonasCampo2) >= numMin) {
            hasErrorNumeroPersonasValidacion = false
          }
        }
      }
      else if (planElegido && (planElegido.numLabels === '1' || planElegido.numLabels === 1)) {
        if (!hasnumPersonasError && parseInt(numPersonasCampo1) >= numMin) {
          hasErrorNumeroPersonasValidacion = false
        }
      }
      //Validar que las preguntas han sido respondidas en caso que el plan tenga preguntas   

      if (this.state.planSeleccionado === "1015" && this.state.planAigmedSeleccionado == null) {
        planesAigmedError = true
      }

      if (planElegido && planElegido.preguntas) {
        let encontroError = false
        arrayPreguntas.forEach((element, i) => {
          if (element.opcionNo === false) {
            encontroError = true
          }
        });
        if (encontroError === false) {
          hasErrorResponderPreguntas = false
        }
        else {

        
    

        
        
          this.scrollToBottom()
       
          this.setState({
            verMsgErrorPreguntas: true
          })
          
        }
      }
      else {
        hasErrorResponderPreguntas = false
      }
      //validar si el seguro tiene subplan
      if (planElegido.banSubplan && planElegido.banSubplan === true) {
        if (subPlanSeleccionado === '') {
          subplanValidador = false
          this.toggleValidating(true);
        }
      }
    }

    // Llamar al servicio de validación de duplicidad de poliza
    const checkDuplicidadObj = {
      empresa: "AIGMETROPOLITANA",
      plataforma: 'WEB',
      identificacion: ruc,
      ramo: EquiRamos.ap,
    };
    console.log('checkDuplicidadObj pymes', checkDuplicidadObj,);
    await this.props.checkIsDuplicate({ type: 'otros', postObj: checkDuplicidadObj });


    // si es que no existe duplicidad, continuar
    if (!this.props.duplicity.isDuplicatePoliza) {
      // continuar si no hubo errores
      if (
        !hasEmpresaError &&
        !hasSolicitanteError &&
        !hasRucError &&
        !hasCedulaError &&
        !hasPlanError &&
        !hasErrorNumeroPersonasValidacion &&
        !hasErrorResponderPreguntas &&
        !hasSucursalError &&
        !this.props.duplicity.duplicidadPolizaError &&
        solicitante !== "" &&
        empresa !== "" &&
        cedula !== "" &&
        planSeleccionado !== "" &&
        numMin !== "" &&
        sucursalSeleccionada !== "" &&
        ruc !== "" &&
        !planesAigmedError &&
        subplanValidador &&
        !actividadHasError &&
        actividadSelected !== ''
      ) {
        this.setState({ loadingPaso: true });

        // console.log(planSeleccionado);
        // console.log(subPlanSeleccionado);
        // console.log(nomSubPlanSeleccionado);
        // console.log(nomSubPlanSeleccionado);


        var planAigEncontrado = this.state.planSeleccionado != "1015" ? "" : this.state.planesAigmed[this.state.planAigmedSeleccionado.value]


        let enviar = {
          empresa: "AIGMETROPOLITANA",
          plataforma: "WEB",
          ambiente: "Desarrollo",
          sucursal: this.state.sucursalSeleccionada,
          empresaNombre: empresa,
          empresaRuc: ruc,
          solicitanteNombre: solicitante,
          solicitanteCedula: cedula,
          idAsesor: this.props.datosUsuarios.cliCodigoCore, //enviar el id del logueado
          pasoCarrito: "inicio",
          plan: {
            id: planSeleccionado,
            name: nomPlanSeleccionado,
            descripcion:desPlanSeleccionado
          },
          subplanes: {
            id: subPlanSeleccionado,
            name: nomSubPlanSeleccionado
          },
          provincia: this.state.provinciaSelected,
          ciudad: this.state.ciudadSelected,
          idCarrito: this.state.idCarrito ? this.state.idCarrito : "",
          direccion: this.state.direccionSelected,
          numPersonasTotal: numPersonasCampo1,
          numAdministrativos: numPersonasCampo2,
          objetoAsesor: {
            nombre: `${this.props.datosAsesor.nombres} ${this.props.datosAsesor.apellidos}`,
            codigoCore: this.props.datosAsesor.cliCodigoCore,
            sucursalSeleccionada: this.state.sucursalSeleccionada,
            ambiente: ambienteAplicacion,
            emailAsesor: this.props.datosAsesor.correo ? this.props.datosAsesor.correo : '',
            brokerRUC: this.props.datosAsesor.brokerRUC ? this.props.datosAsesor.brokerRUC : '',
            brokerNombre: this.props.datosAsesor.brokerNombre ? this.props.datosAsesor.brokerNombre : '',
            brokerCodigo: this.props.datosAsesor.brokerCodigo ? this.props.datosAsesor.brokerCodigo : '',
          },
          actividad: actividadSelected
        }
        if (this.state.planSeleccionado == "1015") {
          enviar.actividadAigmed = planAigEncontrado
        }
        console.log(JSON.stringify(enviar))
        await this.props.crearCarrito(enviar);

        if (!this.props.datosCarritoAcc.crearCarritoAccPError) {
          this.setState({
            idCarrito: this.props.datosCarritoAcc.productoAccP.mongoCarrito
          });
          console.log('test1 david');
          this.props.history.push({
            pathname: "/servicios-cotizacion-accidente-personal"
          });
        }
      } else {
        console.log("NO VALIDO");
      }
    }

  }

  async cambiarRucId(identificacion, tipo) {
    await this.props.consultarIdentificacion({
      empresa: "AIGMETROPOLITANA",
      identificador: identificacion,
      tipo: tipo
    });

    if (!this.props.datosIdentificacionAP.consultarIdentificacionAPhasError) {
      if (
        tipo === "ruc" &&
        this.props.datosIdentificacionAP.IdentificacionAP[0] !== undefined
      ) {
        this.setState({
          empresa: this.props.datosIdentificacionAP.IdentificacionAP[0].nombre,
          hasEmpresaError: false,
          validate: true
        });
      } else if (
        tipo === "cedula" &&
        this.props.datosIdentificacionAP.IdentificacionAP[0] !== undefined
      ) {
        this.setState({
          solicitante: this.props.datosIdentificacionAP.IdentificacionAP[0]
            .nombre,
          hasSolicitanteError: false,
          validate: true
        });
      }
    } else {
      if (tipo === "ruc") {
        this.setState({
          empresa: ""
        });
      } else if (tipo === "cedula") {
        this.setState({
          solicitante: ""
        });
      }
    }
  }

  async componentDidMount() {
     window.scroll(0, 0);

    //obtener sucursales
    await this.props.fethSucursales();

    //se obtiene provincias

    await this.props.obtenerProvincias("AIGMETROPOLITANA", "travel");

    if (!this.props.listaProvinciasAP.obtenerProviciasAPError) {

      let arrayProvincias = [];
      this.props.listaProvinciasAP.provinciasAP.map(p => {
        arrayProvincias.push({ value: p.provCodigoCore, label: p.label });
      });

      this.setState({
        arrayProvincias
      });

    }

    //se obtiene planes
    await this.props.obtenerPlanes({
      empresa: "AIGMETROPOLITANA",
      cotizador: "accidentesPersonales"
    });

    await this.props.obtenerPlanesAigmed()

    this.setState(
      {
        planesAigmed: this.props.listaPlanesAccP.planesAccPAigmed
      }
    )

    console.log('this.props.obtenerplanes before', this.props);
    if (!this.props.listaPlanesAccP.obtenerPlanesAccPhasError) {
      console.log('this.props.obtenerplanes afeter', this.props.listaPlanesAccP.planesAccPAigmed);
      this.setState({
        arrayActividades: this.props.listaPlanesAccP.planesCotizacionAccP.actividades ? this.props.listaPlanesAccP.planesCotizacionAccP.actividades : [],
        planes: this.props.listaPlanesAccP.planesCotizacionAccP.planes,
        numMin: parseInt(
          this.props.listaPlanesAccP.planesCotizacionAccP.minPersonasCotizar
        ),
        msgConfirmarRecalculo: this.props.listaPlanesAccP.planesCotizacionAccP.msgConfirmarRecalculo
      });
    }

    //se obtiene el id desde la url

    const queryParams = new URLSearchParams(this.props.location.search);
    const idCarrito = queryParams.get("id");

    if (idCarrito !== undefined && idCarrito !== null && idCarrito !== "") {
      await this.props.recuperarCarrito({
        empresa: "AIGMETROPOLITANA",
        idCarrito: idCarrito
      });

      const {
        datosContratanteEmpresa,
        datosContratantePersona,
        datosUbicacion,
        carProductos,
        carDatosAsesor
      } = this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP;
      this.setState({
        empresa: datosContratanteEmpresa.cliRazonSocial,
        solicitante: datosContratantePersona.nombreCompleto,
        ruc: datosContratanteEmpresa.cliIdentificacion,
        cedula: datosContratantePersona.cliIdentificacion,
        idCarrito,
        hasEmpresaError: false,
        hasSolicitanteError: false,
        hasRucError: false,
        hasCedulaError: false,
        idAsesor: this.props.datosUsuarios.cliCodigoCore, //enviar el id del logueado
        sucursalSeleccionada: carDatosAsesor.sucursalSeleccionada,
        provinciaSelected: datosUbicacion.provincia,
        hasProvinciaError: datosUbicacion.provincia !== "" ? false : true,
        ciudadSelected: datosUbicacion.ciudad,
        hasCiudadError: datosUbicacion.ciudad !== "" ? false : true,
        direccionSelected: datosUbicacion.direccion,
        hasDireccionError: datosUbicacion.direccion !== "" ? false : true,
        planSeleccionado: carProductos[0].plan.id,
        subPlanSeleccionado: carProductos[0].subplanes.id,
        numPersonas: carProductos[0].numPersonasTotal,
        numPersonasCampo1: carProductos[0].numPersonasTotal,
        numPersonasCampo2: carProductos[0].numAdministrativos,
        hasnumPersonasError: carProductos[0].numPersonasTotal ? false : true,
        hasnumPersonas2Error: carProductos[0].numAdministrativos ? false : true,
        hasSucursalError: carDatosAsesor.sucursalSeleccionada ? false : true,
        actividadSelected: carProductos[0].actividad ? carProductos[0].actividad : '',
        actividadHasError: carProductos[0].actividad ? false : true,
      });


      //Marcar las preguntas        
      if (carProductos[0].respondioPreguntas && carProductos[0].respondioPreguntas === true) {
        const { arrayPreguntas } = this.state;
        let arrayPreguntasRespondidas = arrayPreguntas ? arrayPreguntas : undefined
        if (arrayPreguntasRespondidas && arrayPreguntasRespondidas !== undefined) {
          arrayPreguntasRespondidas.forEach((element, i) => {
            arrayPreguntasRespondidas[i] = { ...arrayPreguntasRespondidas[i], opcionSi: false, opcionNo: true }
          });
          this.setState({
            arrayPreguntas: arrayPreguntasRespondidas
          })
        }
      }

    }
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.empresa !== this.state.empresa) {
      if (this.state.empresa !== "") {
        this.setState({ hasEmpresaError: false });
      } else {
        this.setState({ hasEmpresaError: true });
      }
    }

    if (prevState.solicitante !== this.state.solicitante) {
      if (this.state.solicitante !== "") {
        this.setState({ hasSolicitanteError: false });
      } else {
        this.setState({ hasSolicitanteError: true });
      }
    }

    if (prevState.planSeleccionado !== this.state.planSeleccionado) {
      if (this.state.planSeleccionado !== "") {
        this.setState({ hasPlanError: false });

        let ListaPlanes = this.state.planes;
        let planActual = this.state.planSeleccionado;

        //let approved = ListaPlanes.filter(plan => plan.id = 1013);        
        let planElegido = ListaPlanes.find(
          plan => plan.id === planActual
        );
        console.log('planElegido', planElegido)
        //mensaje numero de personas
        let msgnumper = `El número total de personas ingresadas debe ser mínimo ${this.state.numMin}`
        let msgnumperAdmin = `El número total de personas ingresadas debe ser mínimo ${this.state.numMin}`
        if (planElegido.numLabels && (planElegido.numLabels === '2' || planElegido.numLabels === 2)) {
          msgnumperAdmin = `El  ${planElegido.label1.replace('Número de guardias', 'número mínimo de personas').toUpperCase()} A COTIZAR ES ${this.state.numMin} ESTE PUEDE SER LA SUMA ENTRE GUARDIAS Y ADMINISTRATIVOS.`
          msgnumper = `El  ${planElegido.label1.replace('Número de guardias', 'número mínimo de personas').toUpperCase()} A COTIZAR ES ${this.state.numMin} ESTE PUEDE SER LA SUMA ENTRE GUARDIAS Y ADMINISTRATIVOS.`
        }
        //Validar si el plan seleccionado tiene preguntas
        let arraypreguntasValor = undefined
        let msgErrorPreguntasValor = undefined
        let verMsgErrorPreguntasValor = false
        if (planElegido.preguntas) {
          arraypreguntasValor = planElegido.preguntas
          arraypreguntasValor.forEach((element, i) => {
            arraypreguntasValor[i] = { ...arraypreguntasValor[i], opcionSi: false, opcionNo: false }
          });
          if (planElegido.mensajeErrorPreguntas) {
            msgErrorPreguntasValor = planElegido.mensajeErrorPreguntas
          }
        }

        console.log('planElegido',planElegido)
        await this.setState({
          desPlanSeleccionado: planElegido.descripcion,
          nomPlanSeleccionado:planElegido.name,
          subPlan: planElegido.banSubplan,
          subPlanes: planElegido.banSubplan ? planElegido.subPlanes : [],
          labelNumPersonasCampo1: planElegido.label1 ? planElegido.label1 : '',
          labelNumPersonasCampo2: planElegido.label2 ? planElegido.label2 : '',
          msgNumeroPersonas: msgnumper,
          msgNumeroPersonasAdmin: msgnumperAdmin,
          arrayPreguntas: arraypreguntasValor,
          msgErrorPreguntas: msgErrorPreguntasValor,
          verMsgErrorPreguntas: verMsgErrorPreguntasValor
        });
      }
      else {
        await this.setState({
          numPersonasCampo1: 0,
          numPersonasCampo2: 0,
          labelNumPersonasCampo1: "",
          labelNumPersonasCampo2: "",
          hasnumPersonasError: true,
          hasnumPersonas2Error: true,
          mostrarmensajeNumPersonas: true,
          msgNumeroPersonas: '',
          msgNumeroPersonasAdmin: '',
          arrayPreguntas: undefined,
          verMsgErrorPreguntas: false
        });
      }
    }

    if (prevState.subPlanSeleccionado !== this.state.subPlanSeleccionado) {
      if (this.state.subPlanSeleccionado !== "") {
        let ListaPlanes = this.state.subPlanes;
        let planActual = this.state.subPlanSeleccionado;

        //let approved = ListaPlanes.filter(plan => plan.id = 1013);
        let subPlanElegido = ListaPlanes.find(plan => plan.id === planActual);

        this.setState({
          nomSubPlanSeleccionado:
            subPlanElegido && subPlanElegido.name
              ? subPlanElegido.name
              : this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP
                .carProductos[0].subplanes.name
        });
      }
    }

    if (prevState.provinciaSelected !== this.state.provinciaSelected) {
      if (this.state.provinciaSelected !== "") {
        //se manda a listar las provincias
        await this.props.obtenerCiudades({
          empresa: "AIGMETROPOLITANA",
          codProvincia: this.state.provinciaSelected.value,
          ramo: "travel"
        });

        console.log(
          "lista ciudades",
          this.state.provinciaSelected.value,
          "-",
          this.props.listaCiudadesAP
        );

        if (
          this.props.listaCiudadesAP &&
          !this.props.listaCiudadesAP.obtenerCiudadesAPError &&
          this.props.listaCiudadesAP.ciudadesAP
        ) {
          this.setState({
            arrayCiudades: this.props.listaCiudadesAP.ciudadesAP.ciudades
          });
        }
      } else {
        this.setState({ hasProvinciaError: true });
      }
    }
  }




  render() {


 

    let arraySucursales = [];
    this.props.sucursales.map(s => {
      arraySucursales.push({ id: s.sucCodigoCore, name: s.sucNombre });
    });

    arraySucursales.unshift({ id: "", name: "Seleccione una opción" });

    let arrayProvincias = this.state.arrayProvincias;
    let arrayCiudades = this.state.arrayCiudades;
    const {
      validate,
      empresa,
      solicitante,
      ruc,
      cedula,
      loadingPaso,
      numPersonas,
      planSeleccionado,
      planAigmedSeleccionado,
      subPlanSeleccionado,
      numMin,
      subPlan,
      subPlanes,
      provinciaSelected,
      hasProvinciaError,
      hasCiudadError,
      ciudadSelected,
      direccionSelected,
      cargandoCiudades,
      sucursalSeleccionada,
      numPersonasCampo1,
      numPersonasCampo2,
      labelNumPersonasCampo1,
      labelNumPersonasCampo2,
      mostrarmensajeNumPersonas,
      msgNumeroPersonas,
      msgNumeroPersonasAdmin,
      arrayPreguntas,
      verMsgErrorPreguntas,
      msgErrorPreguntas,
      arrayActividades,
      actividadSelected,
      actividadHasError
    } = this.state;

    let arrayPlanes = this.state.planes.map(p=>({...p, name: p.descripcion, descripcion:p.name}));

    let nuevoArray = []

    this.state.planesAigmed.forEach((plan, index) => {
      const aux = { value: index, label: plan.value }
      nuevoArray.push(aux)
    });

    let arrayPlanesAigmed = nuevoArray;

    console.log('estios ssad: ', arrayPlanes)


    let arraySubplanes = this.state.subPlanes;

    let isLoading =
      this.props.datosIdentificacionAP.consultarIdentificacionAPIsLoading ===
        undefined
        ? false
        : this.props.datosIdentificacionAP.consultarIdentificacionAPIsLoading;
    return (
      <LoadingScreen
        loading={
          isLoading ||
          loadingPaso ||
          this.props.listaProvinciasAP.obtenerProvinciasLoading ||
          this.props.listaPlanesAccP.obtenerPlanesAccPIsLoading ||
          this.props.datosRecuperarCarritoAccP.recuperarCarritoAccPIsLoading ||
          this.props.duplicity.duplicidadPolizaLoading
        }
        bgColor="#f1f1f1"
        spinnerColor="#001871"
        textColor="#676767"
        logoSrc={logo}
        text="Obteniendo datos..."
      >
        <Page
          title="Cotización Accidentes Personales"
          breadcrumbs={[{ name: "Cotización Accidentes", active: true }]}
        >
          <div className="container-step">
            <div className="wrapper-step">
              <div className="arrow-steps clearfix-step">
                <div className="step current"> {` 1. Cotización `} </div>
                <div className="step"> {` 2. Resumen `} </div>
                <div className="step"> {` 3. Confirmación `} </div>
                <div class="step"> {` 4. Forma de Pago `} </div>
                <div class="step"> {` 5. Formulario de Vinculación `} </div>
                <div class="step"> {` 6. Emisión `} </div>
              </div>
            </div>
          </div>

          <Row>
            <Col lg={7} md={12} sm={12} xs={12} className="div-align-center">
              <Card className="flex-row ">
                <CardBody>
                  <h4 style={{ fontWeight: "bold" }} className="mb-5">
                    {" "}
                    Datos del Cliente
                  </h4>
                  <Row>
                    <Col lg={4} md={4} sm={12} xs={12} className="ml-3">
                      <h5>
                        <Label className="bold-font-label">RUC </Label>
                      </h5>
                    </Col>
                    <Col lg={7} md={7} sm={12} xs={12}>
                      <Col lg={12} md={12} sm={12} xs={12}>
                        <Textbox
                          //tabIndex="1" // Optional.[String or Number].Default: none.
                          id="ruc" // Optional.[String].Default: "".  Input ID.
                          name="ruc" // Optional.[String].Default: "". Input name.
                          type="text" // Optional.[String].Default: "text". Input type [text, password, number]. NOTE: provide "text" for better performance since different browsers run differently with "number".
                          value={ruc} // Optional.[String].Default: "".
                          placeholder="Ingrese el RUC ejm: 010493405001" // Optional.[String].Default: "".
                          onChange={(ruc, e) => {
                            this.setState({ ruc, hasRucError: false });

                            if (ruc.length === 13) {
                              this.cambiarRucId(ruc, "ruc");
                            }
                          }}
                          validate={validate}
                          validationCallback={res => {
                            this.setState({
                              hasRucError: res,
                              validate: !res
                            });
                          }}
                          onBlur={e => {
                            console.log(e);
                          }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                          validationOption={{
                            required: true,
                            maxlength: 13,
                            length: 13,
                            //  type: "number", // Optional.[String].Default: "string". Validation type, options are ['string', 'number', 'alphanumeric', 'alpha']
                            reg: /^[0-9]+(\.[0-9]+)?$/, //Optional.[Bool].Default: "" Custom regex.
                            msgOnError:
                              "El número de RUC debe tener 13 carácteres"
                          }}
                        />
                      </Col>
                    </Col>
                  </Row>

                  <Row>
                    <Col lg={4} md={4} sm={12} xs={12} className="ml-3">
                      <h5>
                        <Label className="bold-font-label">
                          Nombre de la empresa{" "}
                        </Label>
                      </h5>
                    </Col>
                    <Col lg={7} md={7} sm={12} xs={12}>
                      <Col lg={12} md={12} sm={12} xs={12}>
                        <Textbox
                          tabIndex="1"
                          type="input"
                          value={empresa}
                          name="empresa"
                          id="empresa"
                          classNameInput={"form-control"}
                          placeholder="Ingrese el nombre de la empresa"
                          onChange={(empresa, e) => {
                            this.setState({
                              empresa: empresa.toUpperCase(),
                              hasEmpresaError: false
                            });
                          }}
                          onBlur={e => {
                            this.setState({ blur: true });
                            //console.log("BLUUUR");
                          }}
                          validate={validate}
                          validationCallback={res => {
                            this.setState({
                              hasEmpresaError: res,
                              validate: !res
                            });

                          }} // Optional.[Func].Default: none. Return the validation result.
                          validationOption={{
                            name: "empresa", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: true,
                            reg: /^[\u00e1\u00e9\u00ed\u00f3\u00fa\u00c1\u00c9\u00cd\u00d3\u00da\u00f1\u00d1A-Za-z0-9 _.]*$/,
                            msgOnError: "Ingrese solo letras, números, espacios, guiones bajos (_) y puntos (.)" // Optional.[Bool].Default: true. To determin if it is a required field.
                          }}
                        />
                      </Col>
                    </Col>
                  </Row>

                  {
                    this.props.listaPlanesAccP.planesCotizacionAccP.msgAdvertenciaCotizador && (
                      <Col md={12} className="div-align-center">
                        <Alert color='warning'>
                          <p style={{ textAlign: "center" }}><i className="fa fa-exclamation-triangle fa-2x" aria-hidden="true" ></i></p>
                          <p style={{ textAlign: "justify" }}>{this.props.listaPlanesAccP.planesCotizacionAccP.msgAdvertenciaCotizador}</p>
                        </Alert>
                      </Col>
                    )
                  }

                  <Row className="mb-3">
                    <Col lg={4} md={4} sm={12} xs={12} className="ml-3">
                      <h5>
                        <Label className="bold-font-label">Actividad de la Empresa</Label>
                      </h5>
                    </Col>
                    <Col lg={7} md={7} sm={12} xs={12}>
                      <Col lg={12} md={12} sm={12} xs={12}>
                        <div title={actividadSelected.label ? actividadSelected.label : ""}>
                          <Select
                            value={actividadSelected}
                            components={makeAnimated()}
                            onChange={(actividad, e) => {
                              this.setState({
                                actividadSelected: actividad,
                                actividadHasError: false
                              });
                              //  this.onChangeProvincia(provincia.value.toString())
                            }}
                            options={arrayActividades}
                            isSearchable={true}
                            placeholder={"Seleccione una actividad"}
                            isMulti={false}
                          />
                        </div>
                        {actividadHasError && (
                          <span style={{ color: "red", fontSize: "1rem" }}>
                            Por favor seleccione una actividad
                          </span>
                        )}
                      </Col>
                    </Col>
                  </Row>

                  <Row>
                    <Col lg={4} md={4} sm={12} xs={12} className="ml-3">
                      <h5>
                        <Label className="bold-font-label">
                          Cédula del solicitante{" "}
                        </Label>
                      </h5>
                    </Col>
                    <Col lg={7} md={7} sm={12} xs={12}>
                      <Col lg={12} md={12} sm={12} xs={12}>
                        <Textbox
                          //tabIndex="1"
                          type="text"
                          value={cedula}
                          name="cedula"
                          id="cedula"
                          classNameInput={"form-control"}
                          placeholder="Ingrese el número de cédula ejm: 010493405" // Optional.[String].Default: "".
                          onChange={(cedula, e) => {
                            this.setState({ cedula, hasCedulaError: false });

                            if (cedula.length === 10) {
                              this.cambiarRucId(cedula, "cedula");
                            }
                          }}
                          validate={validate}
                          validationCallback={res => {
                            this.setState({
                              hasCedulaError: res,
                              validate: !res
                            });
                          }} // Optional.[Func].Default: none. Return the validation result.
                          //   onBlur={(e) => {console.log(e)}}
                          onBlur={e => {
                            console.log(e);
                          }}
                          validationOption={{
                            name: "cedula", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: true,
                            maxlength: 10,
                            length: 10,
                            type: "number",
                            msgOnError:
                              "El número de Cédula debe tener 10 carácteres"
                          }}
                        />
                      </Col>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col lg={4} md={4} sm={12} xs={12} className="ml-3">
                      <h5>
                        <Label className="bold-font-label">
                          Nombre del solicitante{" "}
                        </Label>
                      </h5>
                    </Col>
                    <Col lg={7} md={7} sm={12} xs={12}>
                      <Col lg={12} md={12} sm={12} xs={12}>
                        <Textbox
                          tabIndex="1"
                          type="input"
                          value={solicitante}
                          name="solicitante"
                          id="solicitante"
                          classNameInput={"form-control"}
                          onChange={(solicitante, e) => {
                            this.setState({
                              solicitante: solicitante.toUpperCase(),
                              hasSolicitanteError: false
                            });
                          }}
                          placeholder="Ingrese el nombre del solicitante" // Optional.[String].Default: "".
                          validate={validate}
                          validationCallback={res => {
                            this.setState({
                              hasSolicitanteError: res,
                              validate: !res
                            });
                          }} // Optional.[Func].Default: none. Return the validation result.
                          onBlur={e => {
                            this.setState({ blur: true });
                            //console.log("BLUUUR");
                          }}
                          validationOption={{
                            name: "solicitante", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: true,
                            reg: /^[a-zA-ZáÁéÉíÍóÓúÚñÑüÜ\s]+$/,
                            regMsg:
                              "Por favor ingrese el nombre del solicitante",
                            msgOnError:
                              "El nombre del solicitante esta vacío o contiene simbolos" // Optional.[Bool].Default: true. To determin if it is a required field.
                          }}
                        />
                      </Col>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col lg={4} md={4} sm={12} xs={12} className="ml-3">
                      <h5>
                        <Label className="bold-font-label">Productos </Label>
                      </h5>
                    </Col>
                    <Col lg={7} md={7} sm={12} xs={12}>
                      <Col lg={12} md={12} sm={12} xs={12}>
                        <Select1
                          tabIndex="6" // Optional.[String or Number].Default: none.
                          id={"selectPlanes"} // Optional.[String].Default: "". Input ID.
                          name={"selectPlanes"} // Optional.[String].Default: "". Input name.
                          value={planSeleccionado} // Optional.[String].Default: "".
                          optionList={arrayPlanes} // Required.[Array of Object(s)].Default: [].
                          onChange={(planSeleccionado, e) => {
                            this.setState({ planSeleccionado });
                            console.log("el plan es", planSeleccionado);
                            //console.log(e);
                          }} // Optional.[Func].Default: () => {}. Will return the value.
                          validate={validate}
                          onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                          customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                          validationCallback={res =>
                            this.setState({
                              hasPlanError: res,
                              validate: !res
                            })
                          }
                          validationOption={{
                            name: "selectPlanes", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                            msgOnError: "Por favor seleccione un plan"
                          }}
                        />
                      </Col>
                    </Col>
                  </Row>

                  {planSeleccionado == "1015" &&
                    <Row className="mb-3">
                      <Col lg={4} md={4} sm={12} xs={12} className="ml-3">
                        <h5>
                          <Label className="bold-font-label">Actividades Planes </Label>
                        </h5>
                      </Col>
                      <Col lg={7} md={7} sm={12} xs={12}>
                        <Col lg={12} md={12} sm={12} xs={12}>
                          <Select
                            tabIndex="6" // Optional.[String or Number].Default: none.
                            id={"selectPlanesAigmed"} // Optional.[String].Default: "". Input ID.
                            name={"selectPlanesAigmed"} // Optional.[String].Default: "". Input name.
                            value={planAigmedSeleccionado} // Optional.[String].Default: "".
                            options={arrayPlanesAigmed} // Required.[Array of Object(s)].Default: [].
                            onChange={(planAigmedSeleccionado, e) => {
                              this.setState({ planAigmedSeleccionado });
                              console.log("el plan es", planAigmedSeleccionado);
                              //console.log(e);
                            }} // Optional.[Func].Default: () => {}. Will return the value.
                            validate={validate}
                            onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                            customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                            isSearchable={true}
                            placeholder={"Seleccione una actividad"}
                            validationCallback={res =>
                              this.setState({
                                hasPlanError: res,
                                validate: !res
                              })
                            }
                            validationOption={{
                              name: "selectPlanesAigmed", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                              check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                              required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                              msgOnError: "Por favor seleccione una actividad"
                            }}
                          />
                        </Col>
                      </Col>
                    </Row>
                  }

                  {subPlan && subPlanes && subPlanes.length > 0 && (
                    <Row className="mb-3">
                      <Col lg={4} md={4} sm={12} xs={12} className="ml-3">
                        <h5>
                          <Label className="bold-font-label">SubPlan </Label>
                        </h5>
                      </Col>
                      <Col lg={7} md={7} sm={12} xs={12}>
                        <Col lg={12} md={12} sm={12} xs={12}>
                          <Select2
                            tabIndex="6" // Optional.[String or Number].Default: none.
                            id={"selectSubPlanes"} // Optional.[String].Default: "". Input ID.
                            name={"selectSubPlanes"} // Optional.[String].Default: "". Input name.
                            value={subPlanSeleccionado} // Optional.[String].Default: "".
                            optionList={arraySubplanes} // Required.[Array of Object(s)].Default: [].
                            onChange={(subPlanSeleccionado, e) => {
                              this.setState({ subPlanSeleccionado });
                              //console.log(e);
                            }} // Optional.[Func].Default: () => {}. Will return the value.
                            onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                            customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                            validate={validate}
                            validationCallback={res =>
                              this.setState({
                                hasPlanError: res,
                                validate: !res
                              })
                            }
                            validationOption={{
                              name: "selectSubPlanes", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                              check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                              required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                              msgOnError: "Por favor seleccione un Subplan"
                            }}
                          />
                        </Col>
                      </Col>
                    </Row>
                  )}

                  {labelNumPersonasCampo1 !== undefined && labelNumPersonasCampo1 !== "" &&
                    <Row className="mb-3">
                      <Col lg={4} md={4} sm={12} xs={12} className="ml-3">
                        <h5><Label className="bold-font-label">{labelNumPersonasCampo1}</Label></h5>
                      </Col>
                      <Col lg={7} md={7} sm={12} xs={12}>
                        <Col lg={12} md={12} sm={12} xs={12}>
                          <Textbox
                            id="numPersonas1" // Optional.[String].Default: "".  Input ID.
                            name="numPersonas1" // Optional.[String].Default: "". Input name.
                            type="number" // Optional.[String].Default: "text". Input type [text, password, number]. NOTE: provide "text" for better performance since different browsers run differently with "number".
                            value={numPersonasCampo1} // Optional.[String].Default: "".
                            placeholder={"Ejemplo : 10"} // Optional.[String].Default: "".
                            onChange={(numPersonas1, e) => {
                              let numerDias =
                                numPersonas1 === "" ? "" : parseInt(numPersonas1);
                              this.setState({
                                numPersonasCampo1: numerDias,
                                hasnumPersonasError: false
                              });
                            }}
                            onBlur={e => {
                              this.setState({ blur: true });
                            }}
                            validate={validate}
                            validationCallback={res => {
                              this.setState({
                                hasnumPersonasError: res,
                                validate: !res
                              });
                            }}
                            validationOption={{
                              check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                              required: true,
                              type: "number", // Optional.[String].Default: "string". Validation type, options are ['string', 'number', 'alphanumeric', 'alpha'].
                              min: 0,
                              //max: numMin, // Optional.[Number].Default: 0. Validation of min length when validationOption['type'] is string, min amount when validationOption['type'] is number.
                              //reg: /^[0-9]+$/, //Optional.[Bool].Default: "" Custom regex.
                              //regMsg:"Por favor ingrese solo carácteres númericos",
                              msgOnError:
                                "Ingrese solo caracteres númericos"
                            }}
                          />
                          {mostrarmensajeNumPersonas && mostrarmensajeNumPersonas === true && ((parseInt(numPersonasCampo1) + parseInt(numPersonasCampo2)) < parseInt(this.state.numMin)) &&
                            <span style={{ color: "red", fontSize: "1rem" }}>{msgNumeroPersonas}</span>
                          }
                        </Col>
                      </Col>
                    </Row>
                  }
                  {labelNumPersonasCampo2 !== undefined && labelNumPersonasCampo2 !== "" &&
                    <Row className="mb-3">
                      <Col lg={4} md={4} sm={12} xs={12} className="ml-3">
                        <h5><Label className="bold-font-label">{labelNumPersonasCampo2}</Label></h5>
                      </Col>
                      <Col lg={7} md={7} sm={12} xs={12}>
                        <Col lg={12} md={12} sm={12} xs={12}>
                          <Textbox
                            id="numPersonas2" // Optional.[String].Default: "".  Input ID.
                            name="numPersonas2" // Optional.[String].Default: "". Input name.
                            type="number" // Optional.[String].Default: "text". Input type [text, password, number]. NOTE: provide "text" for better performance since different browsers run differently with "number".
                            value={numPersonasCampo2} // Optional.[String].Default: "".
                            placeholder={"Ejemplo : 10"} // Optional.[String].Default: "".
                            onChange={(numPersonas2, e) => {
                              let numerDias =
                                numPersonas2 === "" ? "" : parseInt(numPersonas2);
                              this.setState({
                                numPersonasCampo2: numerDias,
                                hasnumPersonas2Error: false
                              });
                            }}
                            onBlur={e => {
                              this.setState({ blur: true });
                            }}
                            validate={validate}
                            validationCallback={res => {
                              this.setState({
                                hasnumPersonas2Error: res,
                                validate: !res
                              });
                            }}
                            validationOption={{
                              check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                              required: true,
                              type: "number", // Optional.[String].Default: "string". Validation type, options are ['string', 'number', 'alphanumeric', 'alpha'].
                              min: 0, // Optional.[Number].Default: 0. Validation of min length when validationOption['type'] is string, min amount when validationOption['type'] is number.
                              //max: numMin,
                              //reg: /^[0-9]+$/, //Optional.[Bool].Default: "" Custom regex.
                              //regMsg:"Por favor ingrese solo carácteres númericos",
                              msgOnError:
                                "Ingrese caracteres númericos "
                            }}
                          />
                          {mostrarmensajeNumPersonas && mostrarmensajeNumPersonas === true && ((parseInt(numPersonasCampo1) + parseInt(numPersonasCampo2)) < parseInt(this.state.numMin)) &&
                            <span style={{ color: "red", fontSize: "1rem" }}>{msgNumeroPersonasAdmin}</span>
                          }
                        </Col>
                      </Col>
                      {
                        this.props.listaPlanesAccP.planesCotizacionAccP.msgAdvertenciaAsegurados && (
                          <Col md={12} className="div-align-center">
                            <Alert color='warning'>
                              <p style={{ textAlign: "justify" }}>
                                <i style={{marginRight: '10px'}} className="fa fa-exclamation-triangle fa-2x" aria-hidden="true" ></i>
                                {this.props.listaPlanesAccP.planesCotizacionAccP.msgAdvertenciaAsegurados}
                              </p>
                            </Alert>
                          </Col>
                        )
                      }
                    </Row>
                  }

                  {/* <Row className="mb-3" style={{display:"none"}}>
                    <Col lg={4} md={4} sm={12} xs={12} className="ml-3">
                      <h5>
                        <Label className="bold-font-label">
                          Número de personas{" "}
                        </Label>
                      </h5>
                    </Col>
                    <Col lg={7} md={7} sm={12} xs={12}>
                      <Col lg={8} md={8} sm={12} xs={12}>
                        <Textbox
                          tabIndex="0" // Optional.[String or Number].Default: none.
                          id="numPersonas" // Optional.[String].Default: "".  Input ID.
                          name="numPersonas" // Optional.[String].Default: "". Input name.
                          type="text" // Optional.[String].Default: "text". Input type [text, password, number]. NOTE: provide "text" for better performance since different browsers run differently with "number".
                          value={numPersonas} // Optional.[String].Default: "".
                          placeholder={"Mímimo " + numMin + " persona"} // Optional.[String].Default: "".
                          onChange={(numPersonas, e) => {
                            let numerDias =
                              numPersonas === "" ? "" : parseInt(numPersonas);
                            this.setState({
                              numPersonas: numerDias,
                              hasnumPersonasError: false
                            });
                          }}
                          onBlur={e => {
                            this.setState({ blur: true });
                            //console.log("BLUUUR");
                          }}
                          validate={validate}
                          validationCallback={res => {
                            this.setState({
                              hasnumPersonasError: res,
                              validate: !res
                            });
                          }}
                          validationOption={{
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: true,
                            type: "number", // Optional.[String].Default: "string". Validation type, options are ['string', 'number', 'alphanumeric', 'alpha'].
                            min: numMin, // Optional.[Number].Default: 0. Validation of min length when validationOption['type'] is string, min amount when validationOption['type'] is number.
                            //reg: /^[0-9]+$/, //Optional.[Bool].Default: "" Custom regex.
                            //regMsg:"Por favor ingrese solo carácteres númericos",
                            msgOnError:
                              "Ingrese solo caracteres númericos y un mínimo de " +
                              numMin +
                              " personas"
                          }}
                        />
                      </Col>
                    </Col>
                  </Row> */}

                  <hr />

                  <h4 style={{ fontWeight: "bold" }} className="mb-5">
                    {" "}
                    Ubicación
                  </h4>

                  <Row className="mb-3">
                    <Col lg={4} md={4} sm={12} xs={12} className="ml-3">
                      <h5>
                        <Label className="bold-font-label">Provincia </Label>
                      </h5>
                    </Col>
                    <Col lg={7} md={7} sm={12} xs={12}>
                      <Col lg={12} md={12} sm={12} xs={12}>
                        <Select
                          value={provinciaSelected}
                          components={makeAnimated()}
                          onChange={(provincia, e) => {
                            this.setState({
                              provinciaSelected: provincia,
                              ciudadSelected: "",
                              hasProvinciaError: false
                            });
                            //  this.onChangeProvincia(provincia.value.toString())
                          }}
                          options={arrayProvincias}
                          isSearchable={true}
                          placeholder={"Seleccione una provincia"}
                          isMulti={false}
                        />
                        {hasProvinciaError && (
                          <span style={{ color: "red", fontSize: "1rem" }}>
                            Por favor seleccione una provincia
                          </span>
                        )}
                      </Col>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col lg={4} md={4} sm={12} xs={12} className="ml-3">
                      <h5>
                        <Label className="bold-font-label">Ciudad </Label>
                      </h5>
                    </Col>
                    <Col lg={7} md={7} sm={12} xs={12}>
                      <Col lg={12} md={12} sm={12} xs={12}>
                        <Select
                          value={ciudadSelected}
                          components={makeAnimated()}
                          onChange={(ciudad, e) => {
                            this.setState({
                              ciudadSelected: ciudad,
                              hasCiudadError: false
                            });
                          }}
                          options={arrayCiudades}
                          isSearchable={true}
                          placeholder={"Seleccione una ciudad"}
                          isMulti={false}
                        />

                        {hasCiudadError && (
                          <span style={{ color: "red", fontSize: "1rem" }}>
                            Por favor seleccione una ciudad
                          </span>
                        )}
                      </Col>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col lg={4} md={4} sm={12} xs={12} className="ml-3">
                      <h5>
                        <Label className="bold-font-label">Dirección </Label>
                      </h5>
                    </Col>
                    <Col lg={7} md={7} sm={12} xs={12}>
                      <Col lg={12} md={12} sm={12} xs={12}>
                        <Textarea
                          tabIndex="1"
                          type="input"
                          value={direccionSelected}
                          name="direccion"
                          id="direccion"
                          classNameInput={"form-control"}
                          onChange={(direccion, e) => {
                            this.setState({
                              direccionSelected: direccion.toUpperCase(),
                              hasDireccionError: false
                            });
                          }}
                          placeholder="Ingrese la dirección" // Optional.[String].Default: "".
                          validate={validate}
                          validationCallback={res => {
                            this.setState({
                              hasDireccionError: res,
                              validate: !res
                            });
                          }} // Optional.[Func].Default: none. Return the validation result.
                          onBlur={e => {
                            this.setState({ blur: true });
                            //console.log("BLUUUR");
                          }}
                          validationOption={{
                            name: "Dirección", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your {name}.
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: false, // Optional.[Bool].Default: true. To determin if it is a required field.
                            //msgOnError: "Debe ingresar una dirección." // Optional.[Bool].Default: true. To determin if it is a required field.
                            customFunc: res => {
                              //Optional.[Func].Default: none. Custom function. Returns true or err message
                              res = direccionSelected;
                              if (
                                res === "" ||
                                res === null ||
                                res === undefined
                              ) {
                                this.setState({ direccionSelected: "" });
                                return "Debe ingresar una dirección.";
                              }
                              return true;
                            }
                          }}
                        />
                      </Col>
                    </Col>
                  </Row>
                  <div ref={this.messagesEndRef}></div>
                  {arrayPreguntas !== undefined &&
                    <div>
                      <hr />
                      <h4 style={{ fontWeight: "bold" }} > {" "} Responda las siguientes Preguntas</h4>
                    </div>
                  }
                  {arrayPreguntas !== undefined && arrayPreguntas.map((preguntas, i) => {
                    console.log('preguntas', arrayPreguntas)
                    return (
                      <div key={i} style={{ margin: "0 2em" }}>
                        <Row >
                          <Col md={8} sm={12} xs={12} className="div-align-center">
                            <p style={{ fontWeight: "200", textAling: "justify" }}>{(i + 1) + '. ' + preguntas.descripcion}</p>
                          </Col>
                          <Col md={4} sm={12} xs={12} className="div-align-center" >
                            <Row>
                              <Col md={6} sm={6} xs={6} >
                                <Checkbox
                                  id={`preguntaSI${preguntas.codigo}`} // Optional.[String].Default: "".  Input ID.
                                  name={`preguntaSI${preguntas.codigo}`}
                                  //value={factotal} // Required.[String].Default: "".
                                  onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                  checked={preguntas.opcionSi} // Required.[Bool].Default: false.
                                  onChange={(res, e) => {
                                    if (!res)
                                      arrayPreguntas[i] = { ...arrayPreguntas[i], opcionSi: res }
                                    else
                                      arrayPreguntas[i] = { ...arrayPreguntas[i], opcionSi: res, opcionNo: !res }
                                    this.setState({ arrayPreguntas, verMsgErrorPreguntas: false })
                                  }}
                                  labelHtml={
                                    <div style={{ color: '#4a4a4a', marginTop: '2px', fontWeight: "bold" }}>
                                      SI
                                    </div>
                                  } // Required.[Html].Default: none.
                                  validationOption={{
                                    name: 'preguntaSI', // Optional.[String].Default: "". To display in the Error message. i.e Please check the ${name}.
                                    check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                  }}
                                />
                              </Col>
                              <Col md={6} sm={6} xs={6} >
                                <Checkbox
                                  id={`preguntaNO${preguntas.codigo}`} // Optional.[String].Default: "".  Input ID.
                                  name={`preguntaNO${preguntas.codigo}`}
                                  //value={factotal} // Required.[String].Default: "".
                                  onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                  checked={preguntas.opcionNo} // Required.[Bool].Default: false.
                                  onChange={(res, e) => {
                                    if (!res)
                                      arrayPreguntas[i] = { ...arrayPreguntas[i], opcionNo: res }
                                    else
                                      arrayPreguntas[i] = { ...arrayPreguntas[i], opcionNo: res, opcionSi: !res }
                                    this.setState({ arrayPreguntas, verMsgErrorPreguntas: false })
                                  }}
                                  labelHtml={
                                    <div style={{ color: '#4a4a4a', marginTop: '2px', fontWeight: "bold" }}>
                                      NO
                                    </div>
                                  } // Required.[Html].Default: none.
                                  validationOption={{
                                    name: 'preguntaNO', // Optional.[String].Default: "". To display in the Error message. i.e Please check the ${name}.
                                    check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                  }}
                                />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </div>
                    );
                  })
                  }
                  <div >

                  {verMsgErrorPreguntas &&
                    <Row  >
                      <Col md={10} sm={12} className="div-align-center">
                        <Alert color="danger">
                          <p style={{ textAlign: "center" }}><i className="fa fa-exclamation-triangle fa-2x" aria-hidden="true" ></i></p>
                          <p style={{ textAlign: "center" }}>{msgErrorPreguntas}</p>

                        </Alert>
                      </Col>
                    </Row>
                  }

                  </div>
                 
                  

                  {this.props.datosUsuarios.usu_tipo_usuario !== "cliente" && (
                    <>
                      <hr />

                      <h4 style={{ fontWeight: "bold" }} className="mb-5">
                        {" "}
                        SUCURSAL DE EMISIÓN
                      </h4>

                      <Row className="mb-3">
                        <Col lg={4} md={4} sm={12} xs={12} className="ml-3">
                          <h5>
                            <Label className="bold-font-label">Sucursal </Label>
                          </h5>
                        </Col>
                        <Col lg={7} md={7} sm={12} xs={12}>
                          <Col lg={12} md={12} sm={12} xs={12}>
                            <Select1
                              tabIndex="6" // Optional.[String or Number].Default: none.
                              id={"sucursalSeleccionada"} // Optional.[String].Default: "". Input ID.
                              name={"sucursalSeleccionada"} // Optional.[String].Default: "". Input name.
                              value={sucursalSeleccionada} // Optional.[String].Default: "".
                              optionList={arraySucursales} // Required.[Array of Object(s)].Default: [].
                              onChange={(selec, e) => {
                                //console.log(selec);
                                this.setState({ sucursalSeleccionada: selec });
                              }}
                              validate={validate}
                              validationCallback={res =>
                                //console.log(res)
                                this.setState({
                                  hasSucursalError: res,
                                  validate: !res
                                })
                              }
                              // Optional.[Func].Default: () => {}. Will return the value.
                              onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                              customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                              validationOption={{
                                name: "sucursalSeleccionada", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                msgOnError: "Por favor seleccione una sucursal"
                              }}
                            />
                          </Col>
                        </Col>
                      </Row>
                    </>
                  )}

                  <Row>
                    <div className="div-align-rigth">
                      <Button
                        className="btn btn-primary"
                        onClick={this.validateForm}
                        style={{ display: "block", margin: "auto" }}
                      >
                        <i
                          className="fa fa-chevron-circle-right"
                          aria-hidden="true"
                        />{" "}
                        {"CONTINUAR"}
                      </Button>
                    </div>
                  </Row>

                  {/* Mensaje de error*/}
                  <div style={{ marginTop: '2rem' }}>
                    {/* Validacion de duplicidad */}
                    {console.log('test dup msg', this.props.duplicity)}
                    {this.props.duplicity.isDuplicatePoliza
                      ?
                      <Alert color="danger">
                        <center><p>{ErrorMsgConstants.duplicidad}</p></center>
                      </Alert>
                      :
                      null
                    }
                    {this.props.duplicity.duplicidadPolizaError &&
                      <Alert color="danger" >
                        <center><p>{ErrorMsgConstants.errorServicioDuplicidad}</p></center>
                      </Alert>
                    }
                  </div>

                </CardBody>
              </Card>
            </Col>
          </Row>
        </Page>
      </LoadingScreen>
    );
  }
}

const mapStateToProps = state => ({
  datosIdentificacionAP: state.datosIdentificacionAP,
  datosUsuarios: state.datosUsuarios.dataUsuario,
  datosRecuperarCarritoAccP: state.datosRecuperarCarritoAccP,
  listaPlanesAccP: state.listaPlanesAccP,
  listaProvinciasAP: state.listaProvinciasAP,
  listaCiudadesAP: state.listaCiudadesAP,
  datosCarritoAcc: state.datosCarritoAccP,
  sucursales: state.datosSucursales.DataSucursales,
  datosAsesor: state.datosUsuarios.dataUsuario,
  duplicity: state.datosDuplicidadPolizas,
});

const mapDispatchToProps = dispatch => {
  return {
    consultarIdentificacion: datos =>
      dispatch(fetchConsultarIdentificacionAP(datos)),
    crearCarrito: datos => dispatch(fetchCrearCarritoAccP(datos)),
    recuperarCarrito: datos => dispatch(fetchRecuperarCarritoAccP(datos)),
    obtenerPlanes: datos => dispatch(fetchObtenerPlanes(datos)),
    obtenerPlanesAigmed: datos => dispatch(fetchObtenerPlanesAigmed()),
    obtenerProvincias: (empresa, ramo) =>
      dispatch(fetchListarProvinciasAP(empresa, ramo)),
    obtenerCiudades: datos => dispatch(fetchListarCiudadesAP(datos)),
    fethSucursales: () => dispatch(sucursalesFetch()),
    checkIsDuplicate: (datosCheckDuplicity) => dispatch(isDuplicateHogar(datosCheckDuplicity)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CotizacionAccPersonal)
);
